import { endPoints } from './endpoints';
import Request from '../axios';

const URL_API_SEARCH_EMPLOYEE_SUBCONTRACT = endPoints.empSub;
const URL_API_SEARCH_EMPLOYEE_SUBCONTRACT_V2 = endPoints.empSubV2;
const URL_API_SEARCH_AGENCY = endPoints.agency;
const URL_API_SEARCH_BREAKDOWN_PAYROLL_AGENCY =
  endPoints.breakdownPayrollAgency;
const URL_API_SEARCH_USER_ADMIN = endPoints.userAdmin;
const URL_API_SEARCH_USER_LIST = endPoints.userList;
const URL_API_SEARCH_VAT_CODE = endPoints.vatCode;
const URL_API_SEARCH_PAYMENT_RATE = endPoints.paymentRate;
const URL_API_SEARCH_ASSIGNMENT = endPoints.assignment;
const URL_API_SEARCH_TIME_SHEET = endPoints.timeSheet;
const URL_API_SEARCH_AGENCY_PROSPECT = endPoints.prospectAgency;
const URL_API_SEARCH_BANK = endPoints.bank;
const URL_API_SEARCH_AGENCY_USERS = endPoints.agencyUsers;
const URL_API_SEARCH_COMPANY = endPoints.company;
const URL_API_SEARCH_COMPANY_HAVE_TIMESHEET = endPoints.companiesTimesheets;

const URL_API_SEARCH_AGENCY_HAVE_TIMESHEET = endPoints.agenciesTimesheets;

const URL_API_SEARCH_BREAKDOWN_PAYROLL_COMPANY =
  endPoints.breakdownPayrollCompany;

const URL_API_SEARCH_ASSIGNMENT_IN_SUB = endPoints.assignmentInSub;

const URL_API_SEARCH_AGENCY_RELATION_SUB_BY_TIME_SHEET =
  endPoints.agencyRelationSubcontractorByTimeSheet;

const URL_API_SEARCH_AGENCY_ASSIGN_TO_SUB = endPoints.agencyAssignToSub;

const URL_API_SEARCH_SUB_BY_ASSIGN_AGENCY =
  endPoints.listSubcontractorByPrimary;

const URL_API_SEARCH_COMPANY_BY_SUB = endPoints.companyBySub;

const URL_API_SEARCH_EXPENSE_GROUP = endPoints.expenseGroup;
const URL_API_SEARCH_EXPENSE_LIST = endPoints.expenseList;
const URL_API_USER_GROUPS = endPoints.userGroup;

const URL_API_SEARCH_DRAFT_PAYROLL_COMPANIES = endPoints.draftPayrollCompanies;

const URL_API_SEARCH_DRAFT_PAYROLL_AGENCIES = endPoints.draftPayrollAgencies;

const URL_API_SEARCH_SITE_ID = endPoints.siteId;

const URL_API_SEARCH_USER_ADMIN_COMPANY = endPoints.userAdminCompany;
const URL_API_SEARCH_EMPLOYER = endPoints.employer;
const URL_API_SEARCH_PERMISSION_EMPLOYERS = endPoints.permissionEmployers;

export const searchEmployeeSubcontract = (params: any) =>
  Request.get(URL_API_SEARCH_EMPLOYEE_SUBCONTRACT, { params });
export const searchAgency = (params: any) =>
  Request.get(URL_API_SEARCH_AGENCY, { params });
export const searchBreakdownPayrollAgency = (params: any) =>
  Request.get(URL_API_SEARCH_BREAKDOWN_PAYROLL_AGENCY, { params });
export const searchUserAdmin = (params: any) =>
  Request.get(URL_API_SEARCH_USER_ADMIN, { params });
export const searchUserList = (params: any) =>
  Request.get(URL_API_SEARCH_USER_LIST, { params });
export const searchVATCode = (params: any) =>
  Request.get(URL_API_SEARCH_VAT_CODE, { params });
export const searchPaymentRate = (params: any) =>
  Request.get(URL_API_SEARCH_PAYMENT_RATE, { params });
export const searchAssignment = (params: any) =>
  Request.get(URL_API_SEARCH_ASSIGNMENT, { params });
export const searchTimeSheet = (params: any) =>
  Request.get(URL_API_SEARCH_TIME_SHEET, { params });
export const searchAgencyProspect = (params: any) =>
  Request.get(URL_API_SEARCH_AGENCY_PROSPECT, { params });
// A candidate points at either a live agency or an agency prospect and both
// show in the one Agency column, so the picker has to offer both lists. Shaped
// like the single-endpoint searches so AppSelectSync can read it unchanged.
export const searchAgencyAndProspect = async (params: any) => {
  const [agencies, prospects] = await Promise.all([
    searchAgency(params),
    searchAgencyProspect(params),
  ]);
  const toList = (res: any) =>
    Array.isArray(res?.data?.data) ? res.data.data : [];
  return { data: { data: [...toList(agencies), ...toList(prospects)] } };
};
export const searchBank = (params: any) =>
  Request.get(`${URL_API_SEARCH_BANK}`, { params });
export const searchAgencyUsers = (query: any, param: any) =>
  Request.get(`${URL_API_SEARCH_AGENCY_USERS}/${param}`, { params: query });
export const searchCompany = (params: any) =>
  Request.get(`${URL_API_SEARCH_COMPANY}/search`, { params });
export const searchCompanyHaveTimesheets = (params: any) =>
  Request.get(`${URL_API_SEARCH_COMPANY_HAVE_TIMESHEET}`, { params });
export const searchAgencyHaveTimesheets = (params: any) =>
  Request.get(`${URL_API_SEARCH_AGENCY_HAVE_TIMESHEET}`, { params });
export const searchBreakdownPayrollCompany = (params: any) =>
  Request.get(URL_API_SEARCH_BREAKDOWN_PAYROLL_COMPANY, { params });
export const searchUserAdminCompany = (params: any) =>
  Request.get(URL_API_SEARCH_USER_ADMIN_COMPANY, { params });

export const searchAssignmentInSub = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_ASSIGNMENT_IN_SUB}/${id}`, { params });

export const searchAgencyRelationSubByTimeSheet = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) =>
  Request.get(
    `${URL_API_SEARCH_AGENCY_RELATION_SUB_BY_TIME_SHEET}/${id}/agency`,
    { params },
  );

export const searchAgencyAssignToSub = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_AGENCY_ASSIGN_TO_SUB}/${id}`, { params });
export const searchSubByAssignAgency = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_SUB_BY_ASSIGN_AGENCY}/${id}`, { params });

export const searchCompanyBySubId = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_COMPANY_BY_SUB}/${id}`, { params });

export const searchExpenseGroup = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_EXPENSE_GROUP}/${id}`, { params });
export const searchExpenseList = ({
  id,
  params,
}: {
  id: string;
  params: any;
}) => Request.get(`${URL_API_SEARCH_EXPENSE_LIST}/${id}/expenses`, { params });

export const searchUserGroup = (params: any) =>
  Request.get(URL_API_USER_GROUPS, { params });

export const searchDraftPayrollCompanies = (params: any) =>
  Request.get(URL_API_SEARCH_DRAFT_PAYROLL_COMPANIES, { params });
export const searchDraftPayrollAgencies = (params: any) =>
  Request.get(URL_API_SEARCH_DRAFT_PAYROLL_AGENCIES, { params });

export const searchAgencyContacts = (query: any, param: any) =>
  Request.get(`${URL_API_SEARCH_AGENCY}/contact/${param || ''}`, {
    params: query,
  });

export const searchSiteInAgency = (params: any, id: string | number) =>
  Request.get(`${URL_API_SEARCH_SITE_ID}/${id}`, { params });

export const searchEmployeeSubcontractV2 = (params: any) =>
  Request.get(URL_API_SEARCH_EMPLOYEE_SUBCONTRACT_V2, { params });

export const searchBureauEmployer = (params: any) =>
  Request.get(`${URL_API_SEARCH_COMPANY}`, {
    params: {
      ...params,
      paymentModalEmployee: 'PAYEE',
    },
  });

export const searchEmployer = (params: any) =>
  Request.get(URL_API_SEARCH_EMPLOYER, { params });

// GET /company needs companies:list; the Permissions screen's employer picker
// must work without it, so it has its own lookup.
export const searchPermissionEmployer = (params: any) =>
  Request.get(URL_API_SEARCH_PERMISSION_EMPLOYERS, { params });

export const searchEmployeeAssignment = (params: any, id: string) =>
  Request.get(`${URL_API_SEARCH_ASSIGNMENT_IN_SUB}/${id}`, { params });

export const searchExpenseCompany = (params: any, id: string) =>
  Request.get(`${URL_API_SEARCH_COMPANY}/${id}/expenses`, { params });

export default {
  searchEmployeeSubcontract,
  searchAgency,
  searchUserAdmin,
  searchUserList,
  searchVATCode,
  searchPaymentRate,
  searchAssignment,
  searchTimeSheet,
  searchAgencyProspect,
  searchAgencyAndProspect,
  searchBank,
  searchAgencyUsers,
  searchCompany,
  searchCompanyHaveTimesheets,
  searchAgencyHaveTimesheets,
  searchAssignmentInSub,
  searchAgencyRelationSubByTimeSheet,
  searchAgencyAssignToSub,
  searchSubByAssignAgency,
  searchCompanyBySubId,
  searchUserGroup,
  searchDraftPayrollCompanies,
  searchDraftPayrollAgencies,
  searchAgencyContacts,
  searchSiteInAgency,
  searchEmployeeSubcontractV2,
  searchBureauEmployer,
  searchEmployer,
  searchPermissionEmployer,
  searchExpenseCompany,
  searchUserAdminCompany,
  searchEmployeeAssignment,
};
